module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "m-1",
    attrs: {
      "placeholder": "选择售货机",
      "default-first-option": ""
    },
    on: {
      "change": function($event) {
        _vm.getData()
      }
    },
    model: {
      value: (_vm.kioskNo),
      callback: function($$v) {
        _vm.kioskNo = $$v
      },
      expression: "kioskNo"
    }
  }, _vm._l((_vm.kioskNoList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.deviceName,
        "value": item.machine_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "商品SKU"
    },
    model: {
      value: (_vm.productName),
      callback: function($$v) {
        _vm.productName = $$v
      },
      expression: "productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.getData()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), (!_vm.is_checkbox) ? _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "Image",
      "label": "商品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "avatar",
          staticStyle: {
            "height": "50px"
          },
          attrs: {
            "src": scope.row.Image
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kioskNo",
      "label": "机器编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoriesName",
      "label": "品类"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ppwPrice",
      "label": "线上价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ppwPrice != scope.row.price) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(scope.row.ppwPrice))]) : _c('span', [_vm._v(_vm._s(scope.row.ppwPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "库存"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.is_checkbox) ? _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "Image",
      "label": "商品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "avatar",
          staticStyle: {
            "height": "50px"
          },
          attrs: {
            "src": scope.row.Image
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "商品价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kioskNo",
      "label": "机器编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoriesName",
      "label": "品类"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ppwPrice",
      "label": "线上价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ppwPrice != scope.row.price) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(scope.row.ppwPrice))]) : _c('span', [_vm._v(_vm._s(scope.row.ppwPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "库存"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentpage,
      "page-count": _vm.pagesCount,
      "page-sizes": _vm.pagesizes,
      "page-size": _vm.pagesize,
      "total": _vm.pagesCount,
      "layout": " total, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-chahange": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.addProduct()
      }
    }
  }, [_vm._v("确认添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.CloseProduct()
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f191361a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/activity/ProductPutaWay.vue
// module id = 1099
// module chunks = 2